// src/stores/orderStores.ts
// Shared module-level stores for order notifications and customer questions.
// Imported by useNotifications / useQuestions — every hook instance reads the
// same cache, so N widgets share ONE backend fetch.

import { createCollectionStore } from './createCollectionStore';
import { fetchNotifications, fetchMessages } from '../services/orderSync';
import { MOCK_ORDERS_ENABLED } from '../mocks/config';
import type { Notification } from '../types/Notification';
import type { QuestionMessage } from '../types/QuestionMessage';

// Poll every 45s for near-real-time order/question updates (no websocket needed).
const POLL_MS = 45_000;

export const ordersStore = createCollectionStore<Notification>({
  readKey: 'notifications.read.ids',
  // «Удалить» в колокольчике только убирает уведомление (слово владельца 31.10.2026):
  // заказ, его статус и склад не меняются. Помнит этот браузер — как и «прочитано».
  hiddenKey: 'notifications.hidden.ids',
  seedOnce: MOCK_ORDERS_ENABLED,
  pollMs: POLL_MS,
  fetcher: async () => {
    if (MOCK_ORDERS_ENABLED) {
      const { genNotificationsMock } = await import('../mocks/notifications.mock');
      return genNotificationsMock(20);
    }
    return fetchNotifications();
  },
});

export const questionsStore = createCollectionStore<QuestionMessage>({
  readKey: 'questions.read.ids',
  seedOnce: MOCK_ORDERS_ENABLED,
  pollMs: POLL_MS,
  fetcher: async () => {
    if (MOCK_ORDERS_ENABLED) {
      const { genQuestionsMock } = await import('../mocks/questions.mock');
      return genQuestionsMock(20);
    }
    return fetchMessages();
  },
});
